import {Link} from '@app/dashboard/links/link';
import {AdHost} from '@common/admin/ads/ad-host';
import {ShareLinkButton} from '@app/dashboard/links/sharing/share-link-button';
import {Navbar} from '@common/ui/navigation/navbar/navbar';

interface LinkPageRendererProps {
  link: Link;
}
export function LinkIframeRenderer({link}: LinkPageRendererProps) {
  return (
    <div className="h-svh relative flex flex-col">
      <Navbar
        menuPosition="link-page-navbar"
        className="sticky top-0 flex-shrink-0"
        rightChildren={<ShareLinkButton link={link} />}
      />
      <AdHost slot="frame" className="my-20" />
      <iframe src={link.long_url} className="flex-auto" />
    </div>
  );
}
